
const SetupData = {
    countryFlags: [
        {
            name: "Croatia",
            image: "https://iprofstore.blob.core.windows.net/countryflags/croatia.svg"
        },
        {
            name: "Maldives",
            image: "https://iprofstore.blob.core.windows.net/countryflags/maldives.svg"
        },
        {
            name: "Slovenia",
            image: "https://iprofstore.blob.core.windows.net/countryflags/slovenia.svg"
        },
        {
            name: "Vietnam",
            image: "https://iprofstore.blob.core.windows.net/countryflags/vietnam.svg"
        },
        {
            name: "Philippine",
            image: "https://iprofstore.blob.core.windows.net/countryflags/philippine.svg"
        },
        {
            name: "China",
            image: "https://iprofstore.blob.core.windows.net/countryflags/china.svg"
        },
        {
            name: "Japan",
            image: "https://iprofstore.blob.core.windows.net/countryflags/japan.svg"
        },
        {
            name: "Austria",
            image: "https://iprofstore.blob.core.windows.net/countryflags/austria.svg"
        },
        {
            name: "Spain",
            image: "https://iprofstore.blob.core.windows.net/countryflags/spain.svg"
        },
        {
            name: "Finland/Norway",
            image: "https://iprofstore.blob.core.windows.net/countryflags/finland-norway.svg"
        },
        {
            name: "Argentina",
            image: "https://iprofstore.blob.core.windows.net/countryflags/argentina.svg"
        },
        {
            name: "Indonesia",
            image: "https://iprofstore.blob.core.windows.net/countryflags/indonesia.svg"
        },
        {
            name: "Egypt",
            image: "https://iprofstore.blob.core.windows.net/countryflags/egypt.svg"
        },
    ],
    monthNames: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    userStatus: [
        { label: "User Status", value: "User Status" },
        { label: "None", value: "None" },
        { label: "All", value: "All" },
        { label: "Suspended", value: "Suspended" },
        { label: "Resigned", value: "Resigned" },
        { label: "Terminated", value: "Terminated" },
        { label: "Rejoin", value: "Rejoin" },
    ]
}

export default SetupData;